<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'">
          <el-form-item label="邀请用户id" prop="userId">
          <el-input v-model="dataForm.userId" placeholder="邀请用户id"></el-input>
      </el-form-item>
          <el-form-item label="0未发送1已发送2发送失败3发送中" prop="sendStatus">
          <el-input v-model="dataForm.sendStatus" placeholder="0未发送1已发送2发送失败3发送中"></el-input>
      </el-form-item>
      <el-form-item label="投资时间（201607）" prop="countDate">
       
          <el-date-picker
                  v-model="dataForm.countDate"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item>
      <el-form-item label="添加时间" prop="addTime">

          <el-date-picker
                  v-model="dataForm.addTime"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item>
      <el-form-item label="修改时间" prop="modifyTime">
      
          <el-date-picker
                  v-model="dataForm.modifyTime"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item>
          <el-form-item label="活动期间最后投资时间" prop="activeModifyTime">
          
          <el-date-picker
                  v-model="dataForm.activeModifyTime"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item>
          <el-form-item label="投资总金额" prop="totalMoney">
          <el-input v-model="dataForm.totalMoney" placeholder="投资总金额"></el-input>
      </el-form-item>
          <el-form-item label="活动期间投资总金额" prop="activeTotalMoney">
          <el-input v-model="dataForm.activeTotalMoney" placeholder="活动期间投资总金额"></el-input>
      </el-form-item>
          <el-form-item label="总收益" prop="totalInterest">
          <el-input v-model="dataForm.totalInterest" placeholder="总收益"></el-input>
      </el-form-item>
          <el-form-item label="活动期间总收益" prop="activeTotalInterest">
          <el-input v-model="dataForm.activeTotalInterest" placeholder="活动期间总收益"></el-input>
      </el-form-item>
          <el-form-item label="被邀请人投资总额" prop="inviteMoney">
          <el-input v-model="dataForm.inviteMoney" placeholder="被邀请人投资总额"></el-input>
      </el-form-item>
          <el-form-item label="活动期间被邀请人投资总额" prop="activeInviteMoney">
          <el-input v-model="dataForm.activeInviteMoney" placeholder="活动期间被邀请人投资总额"></el-input>
      </el-form-item>
          <el-form-item label="被邀请人投资利息" prop="inviteInterest">
          <el-input v-model="dataForm.inviteInterest" placeholder="被邀请人投资利息"></el-input>
      </el-form-item>
          <el-form-item label="活期期间被邀请人投资利息" prop="activeInviteInterest">
          <el-input v-model="dataForm.activeInviteInterest" placeholder="活期期间被邀请人投资利息"></el-input>
      </el-form-item>
          <el-form-item label="对账状态" prop="reconStatus">
          <el-input v-model="dataForm.reconStatus" placeholder="对账状态"></el-input>
      </el-form-item>
          <el-form-item label="交易订单号" prop="bizFlow">
          <el-input v-model="dataForm.bizFlow" placeholder="交易订单号"></el-input>
      </el-form-item>
      <el-form-item label="预计已返现金额" prop="returnCash">
          <el-input v-model="dataForm.returnCash" placeholder="预计已返现金额"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        userId: '',
        sendStatus: '',
        countDate: '',
        addTime: '',
        modifyTime: '',
        activeModifyTime: '',
        totalMoney: '',
        activeTotalMoney: '',
        totalInterest: '',
        activeTotalInterest: '',
        inviteMoney: '',
        activeInviteMoney: '',
        inviteInterest: '',
        activeInviteInterest: '',
        reconStatus: '',
        bizFlow: '',
        returnCash: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        userId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        sendStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        countDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        addTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        modifyTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        activeModifyTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        totalMoney: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        activeTotalMoney: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        totalInterest: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        activeTotalInterest: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        inviteMoney: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        activeInviteMoney: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        inviteInterest: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        activeInviteInterest: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        reconStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bizFlow: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        returnCash: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/slinvitetender/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/slinvitetender/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
